/**
 * Расшифровка режимов полёта ArduPilot.
 *
 * Раньше эти таблицы жили внутри ModeBox и были доступны только шапке. Сетка
 * дронов показывает режим у каждой плитки, поэтому знание вынесено в утилиту.
 */

const COPTER_MODES: Record<number, string> = {
    0: 'STABILIZE',
    1: 'ACRO',
    2: 'ALT HOLD',
    3: 'AUTO',
    4: 'GUIDED',
    5: 'LOITER',
    6: 'RTL',
    7: 'CIRCLE',
    9: 'LAND',
    11: 'DRIFT',
    13: 'SPORT',
    14: 'FLIP',
    15: 'AUTOTUNE',
    16: 'POSHOLD',
    17: 'BRAKE',
    18: 'THROW',
    19: 'AVOID_ADSB',
    20: 'GUIDED_NOGPS',
    21: 'SMART_RTL',
    22: 'FLOWHOLD',
    23: 'FOLLOW',
    24: 'ZIGZAG',
    25: 'SYSTEMID',
    26: 'AUTOROTATE'
};

const PLANE_MODES: Record<number, string> = {
    0: 'MANUAL',
    1: 'CIRCLE',
    2: 'STABILIZE',
    3: 'TRAINING',
    4: 'ACRO',
    5: 'FLY_BY_WIRE_A',
    6: 'FLY_BY_WIRE_B',
    7: 'CRUISE',
    8: 'AUTOTUNE',
    10: 'AUTO',
    11: 'RTL',
    12: 'LOITER',
    13: 'TAKEOFF',
    14: 'AVOID_ADSB',
    15: 'GUIDED',
    16: 'INITIALIZING',
    17: 'QSTABILIZE',
    18: 'QHOVER',
    19: 'QLOITER',
    20: 'QLAND',
    21: 'QRTL',
    22: 'QAUTOTUNE',
    23: 'QACRO',
    24: 'THERMAL'
};

export const MODE_UNKNOWN = 'UNKNOWN MODE';
export const MODE_OFFLINE = 'OFFLINE';

/** mavType 1 — самолёт, остальное трактуем как коптер (так было в ModeBox). */
export function isPlane(mavType: number): boolean {
    return mavType === 1;
}

export function getModeName(mavType: number, mode: number, isOnline: boolean): string {
    if (!isOnline) {
        return MODE_OFFLINE;
    }
    const table = isPlane(mavType) ? PLANE_MODES : COPTER_MODES;

    return table[mode] ?? MODE_UNKNOWN;
}

/**
 * Режимы, из которых аппарат сам возвращается или садится. Для триажа это не
 * авария, но и не штатный полёт: оператору стоит знать.
 */
export function isReturningOrLanding(mavType: number, mode: number): boolean {
    const name = getModeName(mavType, mode, true);

    return name === 'RTL' || name === 'SMART_RTL' || name === 'QRTL' || name === 'LAND' || name === 'QLAND';
}
